export const KEY_CODES = {
  ESC: 27,
  TAB: 9,
  SPACE: 32,
  ENTER: 13,
  DOWN: 40,
  UP: 38,
  LEFT: 37,
  RIGHT: 39
};
//# sourceMappingURL=key-codes.js.map